import {
  Address,
  Business,
  BusinessInvitation,
  BusinessMembership,
  BusinessRole,
  BusinessStatus,
  InvitationPreview,
} from '../types';

const EMPTY_ADDRESS: Address = {
  line1: '',
  suburb: '',
  state: '',
  postcode: '',
  country: 'AU',
};

export type BusinessDtoBackend = {
  id: string;
  name?: string | null;
  abn?: string | null;
  industry?: string | null;
  status: BusinessStatus;
  createdAt?: string;
  businessPhone?: string | null;
  businessEmail?: string | null;
  contactPerson?: string | null;
  billingAddress?: Address | null;
  shippingAddress?: Address | null;
  ownerUserId?: string | null;
};

export const mapBusinessDto = (b: BusinessDtoBackend): Business => ({
  id: b.id,
  name: b.name ?? '',
  abn: b.abn ?? undefined,
  industry: b.industry ?? undefined,
  businessPhone: b.businessPhone ?? undefined,
  businessEmail: b.businessEmail ?? undefined,
  contactPerson: b.contactPerson ?? undefined,
  billingAddress: b.billingAddress ?? EMPTY_ADDRESS,
  shippingAddress: b.shippingAddress ?? EMPTY_ADDRESS,
  status: b.status,
  ownerUserId: b.ownerUserId ?? '',
});

export type MemberDtoBackend = {
  userId: string;
  email?: string | null;
  fullName?: string | null;
  role: BusinessRole;
  status: BusinessMembership['status'];
  joinedAt?: string | null;
};

export const mapMemberDto = (m: MemberDtoBackend): BusinessMembership => ({
  id: m.userId, // backend doesn't return membershipId; reuse userId as React key
  businessId: '',
  userId: m.userId,
  role: m.role,
  status: m.status,
  joinedAt: m.joinedAt ?? undefined,
  user: {
    fullName: m.fullName ?? '',
    email: m.email ?? '',
  },
});

export type InvitationDtoBackend = {
  id: string;
  invitedEmail?: string | null;
  status: BusinessInvitation['status'];
  expiresAt: string;
  createdAt: string;
};

export const mapInvitationDto = (i: InvitationDtoBackend): BusinessInvitation => ({
  id: i.id,
  businessId: '',
  invitedEmail: i.invitedEmail ?? '',
  invitedByUserId: '',
  token: '',
  expiresAt: i.expiresAt,
  status: i.status,
  createdAt: i.createdAt,
});

export type InvitationPreviewDtoBackend = {
  businessName?: string | null;
  invitedEmail?: string | null;
  expiresAt: string;
  status?: string | null;
};

export const mapInvitationPreviewDto = (
  i: InvitationPreviewDtoBackend,
  token: string,
): InvitationPreview => ({
  invitationId: token,
  businessId: '',
  businessName: i.businessName ?? '',
  invitedEmail: i.invitedEmail ?? '',
  expiresAt: i.expiresAt,
});
